module.exports = __webpack_public_path__ + "static/media/rodovias-fim.7380cb79.png";